/** Portal tenant id — sent as ClientId header on admin API calls. */
export function getPortalClientId(): string {
  return String(process.env.REACT_APP_PAYER_ID ?? "").trim();
}
